/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from '@material-ui/core';
import { FormHandles } from '@unform/core';
import { Form as UForm } from '@unform/web';
import {
  Button, ButtonIcon, Input, WrapperLabel,
} from 'components/Forms';
import Layout from 'components/Layout';
import { useHttp } from 'hooks/http';
import { useToast } from 'hooks/toast';
import React, { useCallback, useRef, useState } from 'react';
import { GrServices } from 'react-icons/gr';
import { useHistory } from 'react-router-dom';
import { InfoIcon } from 'styles/icons';
import getValidationErrors from 'utils/getValidationsErros';
import * as Yup from 'yup';
import {
  Container, Content, GridButtons, WrapperBtnCancel, WrapperBtnInfo, WrapperBtnSubmit,
} from './styles';

const ServiceRJ: React.FC = () => {
  const history = useHistory();
  const { httpPost, loading } = useHttp();
  const formRef = useRef<FormHandles>(null);
  const labelRef = useRef<HTMLLabelElement>(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const { addToast } = useToast();

  const handleSubmit = useCallback(async (data: any) => {
    try {
      setBtnLoading(true);
      // eslint-disable-next-line no-underscore-dangle
      const _service = {
        ...data,
      };
      const schema = Yup.object().shape({
        service_name: Yup.string().required('Nome do serviço é obrigatório'),
      });

      await schema.validate(_service, { abortEarly: false });

      const { status } = await httpPost('social-action/services', {
        ..._service,
      });
      setBtnLoading(false);
      if (status === 201) {
        addToast({ title: 'Salvo com suceso!', type: 'success' });
        formRef.current?.reset();
        history.push('/social-action/services/create');
      } else {
        addToast({ title: 'Não foi possível' });
        history.push('/social-action/services/create');
      }
    } catch (error) {
      setBtnLoading(false);
      formRef.current?.reset();
      if (error instanceof Yup.ValidationError) {
        const erros = getValidationErrors(error);
        formRef.current?.setErrors(erros);
      }
    }
  }, [addToast, history, httpPost]);

  const breadcrumbs = {
    icon: GrServices,
    links: [{ path: '', title: 'Serviços' }],
  };

  return (
    <Layout breadcrumbs={breadcrumbs} loading={loading}>
      <Container>
        <Content>
          <UForm ref={formRef} onSubmit={handleSubmit}>
            <Grid container spacing={1}>
              <WrapperLabel label="Novo serviço" xs={12}>
                <Input
                  name="service_name"
                  style={{ textTransform: 'uppercase' }}
                />
              </WrapperLabel>
            </Grid>
            <GridButtons>
              <WrapperBtnInfo>
                <ButtonIcon
                  title="Instruções"
                  onClick={() => labelRef.current?.click()}
                >
                  <InfoIcon />
                </ButtonIcon>
              </WrapperBtnInfo>
              <WrapperBtnCancel>
                <Button
                  type="button"
                  onClick={() => { history.push('/social-action/services'); }}
                >
                  Cancelar
                </Button>
              </WrapperBtnCancel>
              <WrapperBtnSubmit>
                <Button
                  type="submit"
                  isLoading={btnLoading}
                >
                  Enviar
                </Button>
              </WrapperBtnSubmit>
            </GridButtons>
          </UForm>
        </Content>
      </Container>
    </Layout>
  );
};

export default ServiceRJ;
